import type { Department } from 'types';

const getDepartmentTimezone = (departmentId: number, departments: readonly Department[]): Department['timezonename'] | null =>
    departments.find(({ departmentid }) => `${departmentid}` === `${departmentId}`)?.timezonename ?? null;

export { getDepartmentTimezone };
